import React from 'react'
import { Card } from '@mui/material'
// eslint-disable-next-line import/no-cycle
import { getTileStyles } from './Tile.styles'
import styles from './Tile.module.scss'

export interface TileProps {
  color: 'black' | 'white' | 'gradient' | 'orange' | 'transparent'
  children?: React.ReactNode
  customPadding?: string
  customBorderRadius?: string
  id?: string
  customBackground?: boolean
  title?: string
  height?: string
}

function Tile(props: TileProps) {
  const {
    color,
    children,
    customPadding,
    customBorderRadius,
    id,
    customBackground,
    title,
    height
  } = props

  const tilesStyles = getTileStyles(color, customBackground)
  return (
    <Card
      sx={{
        ...tilesStyles,
        padding: customPadding || '1rem 2rem 2rem 2rem',
        borderRadius: customBorderRadius || '1rem',
        height: height || '100%'
      }}
      id={id}
    >
      {title && (
        <p className={`title-bold-medium ${styles.tileTitle}`}>{title}</p>
      )}
      {children}
    </Card>
  )
}

export default Tile
